import { STOREFRONT_CURRENCY, type Storefront } from '@/hooks/useStorefront';

/**
 * SSOT helper: Storefront → ISO-4217 currency (uppercase).
 *
 * Thin wrapper around the STOREFRONT_CURRENCY map in useStorefront.ts so
 * both the frontend (buildOrderAmounts) and Deno edge functions have a
 * single named entry point. The Deno mirror lives at
 * `supabase/functions/_shared/storefront-currency.ts` and MUST stay
 * byte-identical to the map above (Deno cannot import from `src/`).
 */
export function currencyForStorefront(sf: Storefront): string {
  return STOREFRONT_CURRENCY[sf] ?? 'EUR';
}

export { STOREFRONT_CURRENCY };